export default __webpack_public_path__ + "static/media/glue.5a5c71f7.png";